"use strict";

module.exports = {
  /*<editor-fold desc="[ General routes ]">*/
  ROUTE_PLAYGROUND: '/playground',
  ROUTE_LOGIN: "/login",
  ROUTE_MODULE_SELECTOR: "",
  ROUTE_NOT_FOUND: "*",
  ROUTE_LOGOUT: "logout",
  ROUTE_MY_PROFILE: "my-profile",
  ROUTE_SECURITY: "/security/:action",
  ROUTE_FORGOT_PASSWORD: "/security/forgotPassword",
  /*</editor-fold desc="[ General routes ]">*/

  ROUTE_ERROR: "error",
  ROUTE_ACCESS_DENIED: "access-denied",
  ROUTE_NO_AVAILABLE_MODULES: "no-available-modules",
  ROUTE_SYSTEM_ERROR: "system-error",

  /*<editor-fold desc="[ Reading assessment routes ]">*/
  ROUTE_RA_HOME: "",
  ROUTE_RA_LATEST_ASSESSMENTS: "latest-assessments",
  ROUTE_RA_LEARNERS_PORTFOLIOS: "learners-portfolios",
  ROUTE_RA_LEARNER_PORTFOLIO: "learners-portfolios/:id",
  ROUTE_RA_REPORTS: "reports",
  /*</editor-fold desc="[ Reading assessment routes ]">*/

  /*<editor-fold desc="[ Administration routes ]">*/
  ROUTE_ADMIN_ORGANISATIONS: "organisations",
  ROUTE_ADMIN_MODULES: "modules",
  ROUTE_ADMIN_MODULES_READING_ASSESSMENT: "ra",
  ROUTE_ADMIN_MODULES_OFSTED: "ofsted",
  ROUTE_ADMIN_MODULES_EVIDENCE_ME: "2bap",
  ROUTE_ADMIN_BOOKS_SUBSCRIPTION: "books-subscription",
  ROUTE_ADMIN_INSPECTION_COACH: "inspection-coach",
  ROUTE_ADMIN_QUESTIONNAIRES: "questionnaires",
  ROUTE_ADMIN_CONFIGURE_PLANS: "configure-plans",
  ROUTE_ADMIN_SECTOR_AREAS: "sector-areas",
  ROUTE_ADMIN_ACTIVITY_LOG: "activity-log",
  ROUTE_ADMIN_FRAMEWORKS: "frameworks",
  ROUTE_ADMIN_OBSERVATION_NOTES: "observation-notes",
  ROUTE_ADMIN_OBSERVATION_OBJECTIVES: "observation-objectives",
  ROUTE_ADMIN_REPORT_TEMPLATES: "report-templates",
  ROUTE_ADMIN_ASSESSMENT: "assessment",
  ROUTE_ADMIN_PARENT_SHARE: "parent-share",
  ROUTE_ADMIN_2BAP_SETTINGS: "2bap-settings",
  ROUTE_ADMIN_UPLOAD_FRAMEWORKS: "upload-frameworks",
  /*</editor-fold desc="[ Administration routes ]">*/

  ROUTE_INSPECTION_COACH_HOME: "",

  ROUTE_INSPECTION_CENTRE_HOME: "",
  ROUTE_INSPECTION_CENTRE_CONFIGURE_PLAN: "configure-plan",
  ROUTE_INSPECTION_CENTRE_FILTERS_AND_NOTIFICATIONS: "filters-and-notifications",
  ROUTE_INSPECTION_TASKS: "tasks",
  ROUTE_INSPECTION_TASKS_QUERY_ALL: "all",
  ROUTE_INSPECTION_TASKS_QUERY_MY: "my",
  ROUTE_INSPECTION_TASKS_QUERY_AD_HOC_FILTER: "adHoc",
  ROUTE_INSPECTION_CENTRE_REPORTS: "reports",

  ROUTE_CUSTOM_MODULE: "module",

  ROUTE_2BAP_HOME: "",

  ROUTE_2BAP_REPORTS_BASE: "reports",
  ROUTE_2BAP_REPORTS_LIST: "types",
  ROUTE_2BAP_REPORTS_GENERATION: "generate",
  ROUTE_2BAP_REPORTS_GENERATION_COVERAGE_FLIGHTPATH: "coverage-flightpath-report",
  ROUTE_2BAP_REPORTS_GENERATION_INDIVIDUAL_COVERAGE: "individual-coverage-report",
  ROUTE_2BAP_REPORTS_GENERATION_PLANNING_ASSISTANT: "planning-assistant-report",
  ROUTE_2BAP_REPORTS_GENERATION_LEARNER_OBSERVATION: "learner-observation-report",
  ROUTE_2BAP_REPORTS_GENERATION_GROUP_ASSESSMENT: "group-assessment-report",
  ROUTE_2BAP_LEARNERS_PORTFOLIO_LIST: "learners-portfolios",
  ROUTE_2BAP_OBSERVATION_DETAILS: "observation",
  ROUTE_2BAP_PARENT_SHARE: "parent-share",
  ROUTE_2BAP_ASSESSMENTS: "assessments",

  ROUTE_2BAP_EXTERNAL_IFRAME_REPORTS: "2bap1reports",

  ROUTE_2BAP_EXTERNAL_PROFILE_MODULE_AUTH_ERROR: '2bap-profile-auth-error',
  ROUTE_2BAP_EXTERNAL_PROFILE_MODULE: '2bap-profile',
  ROUTE_2BAP_EXTERNAL_PROFILE_SUMMARY_VIEW: 'summary-view',
  ROUTE_2BAP_EXTERNAL_PROFILE_SUMMARY_EDIT: 'summary-edit',
  ROUTE_2BAP_EXTERNAL_EDIT_ENTITY_PREFIX: 'edit-entity',
  ROUTE_2BAP_EXTERNAL_PROFILE_LEARNER_EDIT: 'learner',
  ROUTE_2BAP_EXTERNAL_PROFILE_CLASS_EDIT: 'class',
  ROUTE_2BAP_EXTERNAL_PROFILE_LEARNER_PROFILE: 'learner-profile',

  ROUTE_2BAP_EXTERNAL_LEARNERS_MODULE: '2bap-learners',
  ROUTE_2BAP_EXTERNAL_LEARNERS_MODULE_SUMMARY_VIEW: 'summary-view',
  ROUTE_2BAP_EXTERNAL_LEARNERS_MODULE_AUTH_ERROR: '2bap-learners-auth-error',
};
